import React from "react";
import { Link } from "react-router-dom";
import { PhoneOff, Link2, Mic, KeyRound, ArrowRight } from "lucide-react";
import { Reveal, StaggerGroup, StaggerItem } from "../components/Reveal";
import { PageHeader } from "./About";
import { useLang } from "../contexts/LanguageContext";
import { t } from "../i18n/translations";

const resourceIcons = [PhoneOff, Link2, Mic, KeyRound];

const Resources = () => {
  const { lang } = useLang();
  const tr = t[lang];

  return (
    <div data-testid="resources-page">
      <PageHeader
        eyebrow={lang === "en" ? "Resources" : "資源"}
        title={tr.resources.title}
        intro={tr.resources.intro}
        heroImage="https://images.pexels.com/photos/7551613/pexels-photo-7551613.jpeg?auto=compress&cs=tinysrgb&w=2000"
      />

      <section className="py-12 lg:py-20">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
          <StaggerGroup className="grid md:grid-cols-2 gap-6">
            {tr.resources.items.map((r, i) => {
              const Icon = resourceIcons[i];
              return (
                <StaggerItem key={i}>
                  <div data-testid={`resource-card-${i}`} className="h-full flex items-start gap-5 bg-[#F8FAFC] hover:bg-white rounded-none border border-slate-100 p-7 hover:shadow-md transition-all">
                    <div className="shrink-0 h-14 w-14 rounded-none bg-white text-[#163B71] flex items-center justify-center border border-slate-100 shadow-sm">
                      <Icon size={22} />
                    </div>
                    <div className="flex-1">
                      <h3 className="font-heading font-semibold text-xl text-[#0A192F]">{r.title}</h3>
                      <p className="mt-2 text-slate-600 leading-relaxed">{r.body}</p>
                      <span className="mt-4 inline-flex items-center gap-1.5 text-xs uppercase tracking-widest font-bold text-[#E9A229]">
                        {lang === "en" ? "Coming soon" : "即將推出"}
                      </span>
                    </div>
                  </div>
                </StaggerItem>
              );
            })}
          </StaggerGroup>

          <Reveal className="mt-16 bg-gradient-to-br from-[#163B71] to-[#0A192F] text-white rounded-none p-10 lg:p-14 text-center relative overflow-hidden">
            <div className="absolute -top-20 -right-20 w-72 h-72 rounded-full bg-[#E9A229]/20 blur-3xl" />
            <h3 className="relative font-heading text-2xl sm:text-3xl font-bold">{lang === "en" ? "Need these resources for your community?" : "想為你的社區索取這些資源？"}</h3>
            <p className="relative mt-3 text-slate-300 max-w-xl mx-auto">{lang === "en" ? "Reach out and we'll share early versions and printable formats with elderly centres and partners." : "歡迎聯絡我們，我們會與長者中心和合作夥伴分享初版及可列印版本。"}</p>
            <Link to="/contact?interest=media" data-testid="resources-cta" className="relative mt-7 inline-flex items-center gap-2 bg-[#E9A229] hover:bg-[#C7841B] text-white px-7 py-3 rounded-full font-bold uppercase tracking-wide text-sm transition-all">
              {lang === "en" ? "Request Resources" : "索取資源"} <ArrowRight size={16} className="btn-arrow" />
            </Link>
          </Reveal>
        </div>
      </section>
    </div>
  );
};

export default Resources;
